import { type AxiosError } from "axios";

/**
 * @return the whole minutes, rounded up, that a rate limited response asks the client to wait, or
 * undefined when Retry-After is missing or is not a number of seconds (e.g. an HTTP date)
 */
export function getRetryAfterMinutes(error: AxiosError) {
  const seconds = Number(error.response?.headers?.["retry-after"]);

  return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds / 60) : undefined;
}
